console.log('hey1')
document.addEventListener("DOMContentLoaded", () => {

  // for each item, remove item from section before adding it
  // check length of array and remove items from section to keep total 
  // the same, for instance, if we're showing 12 items, but adding
  // 2, then we need to get rid of the last two (depending on whether we already deleted some)

  // this code uses info stored in localStorage, so it doesn't know if a product is sold out or on sale

  let recentlyViewedFromStorage = JSON.parse(localStorage.getItem('viewedProducts')) || [];

  console.log('recentlyViewedFromStorage', recentlyViewedFromStorage)
  if (!recentlyViewedFromStorage.length > 0) return;
  // console.log('recentlyViewedFromStorage.length', recentlyViewedFromStorage.length)


  const customGrid = document.querySelector('.section-featured-collection-recents');
  let originalLength = 0;


  // if we have a recently viewed item in the pre-existing content, we will remove it, as we're about to add it again
  const removeItem = function(parentEl, name) {
    const items = parentEl.querySelectorAll('li.grid__item');
    if (items.length > 0) {
      items.forEach((item) => {
        const title = item.querySelector('.card__content a')?.textContent.trim();
        // console.log('title:', title, ' name: ', name)
        if (title === name) {
          console.log('match!')
          item.remove();
        }
      })
    }
  }

  const removeExtraItems =  function(parentEl) {
    const newListItems = parentEl.querySelectorAll('ul.product-grid li');
    // console.log('updated newListItems.length:', newListItems.length, originalLength);
    if (newListItems.length > originalLength) {
      const diff = newListItems.length - originalLength;
      for (let step = 0; step < diff; step++) {
        // console.log("removing an item");
        const removeMe = parentEl.querySelector('ul.product-grid li:last-of-type');
        removeMe.remove();
      }
    }
  };
  async function fetchProductJSON(handle) {
    // console.log('checking handle::', handle)
    const response = await fetch(`/products/${handle}.js`);
    if (!response) return false;
    // console.log('response', response)
    const addedProduct = await response.json();
    if ( !response.ok ) console.log('response failed', response.ok, response.status)
    return addedProduct;
  }

  const checkExtrasPrice =  function(parentEl) {
    const addedProducts = document.querySelectorAll('.added-products');
    if (!addedProducts.length > 0) return;
    // console.log('addedProducts::', addedProducts);

    addedProducts.forEach(prod => {
      if (prod.dataset.added_product) {
        fetchProductJSON(prod.dataset.added_product).then(addedProduct => {
          // console.log('addedProduct:', addedProduct)

          // check for an updated image, just in case
          const prodImage = prod.querySelector('.media img');
          if (!prodImage) return;
          let currentImg = new URL(prod.querySelector('.media img').src).pathname;
          let latestImg = new URL('https://' + addedProduct.featured_image).pathname;
          currentImg = currentImg.slice(currentImg.lastIndexOf('/'));
          latestImg = latestImg.slice(latestImg.lastIndexOf('/'));
          // console.log('currentImg', currentImg)
          // console.log('latestImg', latestImg)
          if (currentImg !== latestImg) {
            console.log('updating image')
            prodImage.src = latestImg
          } 

          // if no image, use default image from settings
          if (!prod.querySelector('.media img').src && !addedProduct.featured_image) {
            const section_wrap = document.querySelector('[data-fallback_img]');
            if (section_wrap) {
              prodImage.src = section_wrap.dataset.fallback_img;
              prodImage.classList.add('fallback_img');
            }
          }

          // now check for sale price
          if (!addedProduct.compare_at_price) return;
          if (addedProduct.compare_at_price > addedProduct.price && addedProduct.available) {
            const badges = prod.querySelectorAll('.card__badge');

            // check theme text for sale badges - this would be an array, but the values are the same, so we only need the first one
            const theme_badge_data = document.querySelector('[data-on_sale_text]');
            let theme_badge_text;
            if (theme_badge_data) theme_badge_text = theme_badge_data.dataset.on_sale_text;
            
            // console.log('badges:', badges)
            // console.log('addedProduct:', addedProduct.title, addedProduct.compare_at_price, addedProduct.price)
            if (badges.length > 0) {
              badges.forEach(el => {
                // console.log('card_badge_type', card_badge_type)
                let onSaleTextNew;
                if (theme_badge_text) {
                  onSaleTextNew = theme_badge_text;
                }
                else if (card_badge_type === 'dollar') {
                  let pricediff = Number.parseFloat((addedProduct.compare_at_price - addedProduct.price) / 100.0).toFixed(2);
                  // for now, let's make it an integer
                  pricediff = Math.floor(pricediff)
                  onSaleTextNew = `Save $${pricediff}`;
                } else {
                  let pricediff = (addedProduct.compare_at_price - addedProduct.price) * 1.0
                  let percent = Math.round((pricediff / addedProduct.compare_at_price) * 100.0);
                  onSaleTextNew = `${percent}% Off`;
                }

                const badgeContent = `<span class="badge badge--bottom-left ${colorBadge}">${onSaleTextNew}</span>`
                el.innerHTML = badgeContent;
              })
            }
            
          }
        })
      }
      
    })
  }
    
  const checkImages =  function(parentEl) {
    // console.log('running checkImages')
    const addedProducts2 = document.querySelectorAll('.added-products');
    if (!addedProducts2.length > 0) return;

    addedProducts2.forEach(el => {
      const addedProductImg = el.querySelector('.added-image');
      
      var completeInterval = null, renderedInterval = null, count = 0;
      
      if (!addedProductImg?.dataset.img_src) return;
      addedProductImg.src = addedProductImg.dataset.img_src;
      addedProductImg.classList.remove('fallback_img');
      // Wait for image to be loaded (but not necessarily rendered)
      completeInterval = setInterval(function() {
        ++count;
        // console.log('running checkImages interval')
        if (addedProductImg.complete || count > 20) {
          // Cancel checking once IMG is loaded OR we've tried for ~9s already
          clearInterval(completeInterval);
          completeInterval = null;
          count = 0;
          if (count > 20) {
            // Image load went wrong, so do something useful:
            console.error("ERROR: Could not load image");
          } else {
            // IMG is now 'complete' - but that just means it's in the render queue...
            // Wait for naturalWidth and naturalHeight to be > 0 since this shows
            // that the image is done being RENDERED (not just 'loaded/complete')
            renderedInterval = setInterval(function() {
              if (addedProductImg.naturalHeight > 0 && addedProductImg.naturalWidth > 0) {
                clearInterval(renderedInterval);
                renderedInterval = null;
                // Do whatever now that image is rendered (aka DONE):
                // console.log("Image loaded - YAY!")
              }
            }, 100);
          }
        }
      }, 450);
    })

  }

  

  if (customGrid) {
    // console.log('restrictToCollection:::', restrictToCollection)
    let customGridProductsToShow;
    if (restrictToCollection) {
      customGridProductsToShow = recentlyViewedFromStorage.filter((el) => {
        // console.log('el.collections:',el.collections)
        return el.collections?.includes(restrictToCollection);
      });
    } else {
      customGridProductsToShow = recentlyViewedFromStorage;
    }
    // console.log('customGridProductsToShow::', customGridProductsToShow)
    


    const listItems = customGrid.querySelectorAll('ul.product-grid li');
    originalLength = listItems.length;
    // console.log('updated originalLength:', originalLength)

    // limit the number of items to display
    // var customGridDisplayLimit is from sections/custom-grid.liquid
    // console.log('customGridProductsToShow before length check', customGridDisplayLimit)
    if (customGridProductsToShow.length > customGridDisplayLimit) customGridProductsToShow.length = customGridDisplayLimit;
    console.log('customGridProductsToShow after length check', customGridProductsToShow)

    let newHtml = '';

    async function fetchDataInParallel(items, section) {
      console.log('hi')
      const promises = items.map(async (el, index) => {
        try {
          const response = await fetch(`/products/${el.handle}.js`);
          if (!response.ok) {
            return false;
            //throw new Error(`HTTP error! status: ${response.status}`);
          }
          const data = await response.json();
          console.log('data::', data)
          var reg_price = data.price / 100;
          reg_price = reg_price.toFixed(2)
          let newHtml = '';
          newHtml = newHtml + `<li id="Slide-template--18369993900226__featured_collection_recents_6Y8WbR-2-${index}" class="grid__item scroll-trigger animate--slide-in added-products" data-cascade="" style="--animation-order: 2;" data-added_product="${data.handle}">
<div class="card-wrapper product-card-wrapper underline-links-hover" data-on_sale_text="Sale">
  <div class="card card--card card--media color-scheme-1 gradient" style="--ratio-percent: 100.0%;">
    <div class="card__inner  ratio" style="--ratio-percent: 100.0%;"><div class="card__media">
      <div class="media media--transparent media--hover-effect">
        <img src="${data.featured_image}" data-img_src="${data.featured_image}" alt="${data.title}" class="motion-reduce" loading="lazy" width="300" height="300">
    </div>
</div><div class="card__content">
<div class="card__information">
  <h3 class="card__heading">
    <a href="${data.url}" id="StandardCardNoMediaLink-template--18369993900226__featured_collection_recents_6Y8WbR-7661518389442-${index}" class="full-unstyled-link" aria-labelledby="StandardCardNoMediaLink-template--18369993900226__featured_collection_recents_6Y8WbR-7661518389442 NoMediaStandardBadge-template--18369993900226__featured_collection_recents_6Y8WbR-7661518389442">
      ${data.title}
    </a>
  </h3>
</div>
<div class="card__badge ${badgePosition}"></div>
</div>
</div>
<div class="card__content bottom">
  <div class="card__information"><div class="caption light tw-text-accent-1">${data.type}</div><h3 class="card__heading" id="title-template--18369993900226__featured_collection_recents_6Y8WbR-7661518389442-${index}">
      <a href="${data.url}" id="CardLink-template--18369993900226__featured_collection_recents_6Y8WbR-7661518389442" class="full-unstyled-link" aria-labelledby="CardLink-template--18369993900226__featured_collection_recents_6Y8WbR-7661518389442 Badge-template--18369993900226__featured_collection_recents_6Y8WbR-7661518389442-${index}">
        ${data.title}
      </a>
    </h3>
    <div class="card-information">
      <div class="price-ratings-wrap">
      <div class="price ">
        <div class="price__container"><div class="price__regular"><span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span class="price-item price-item--regular">
          $ ${reg_price}
        </span></div>
        <div class="price__sale">
        <span class="visually-hidden visually-hidden--inline">Regular price</span>
        <span>
          <s class="price-item price-item--regular">${reg_price}</s>
          </span><span class="visually-hidden visually-hidden--inline">Sale price</span>
      <span class="price-item price-item--sale price-item--last tw-text-accent-2 !tw-bg-background-2 color-scheme-90f2fa4e-da68-4193-b5d5-335e24bcea77">
          ${reg_price}
        </span>
      </div>
      <small class="unit-price caption hidden">
        <span class="visually-hidden">Unit price</span>
        <span class="price-item price-item--last">
          <span></span>
          <span aria-hidden="true">/</span>
          <span class="visually-hidden">&nbsp;per&nbsp;</span>
          <span>
          </span>
        </span>
      </small>
    </div>
  </div>
</div>
</div></div>

<div class="usp-badges-wrap">`;
console.log('el.usp_badges', el.usp_badges)
                if (el.usp_badges) {
                  for (badge of el.usp_badges) {
                    newHtml = newHtml + `<div class="usp-badge ${badge.badge_handle}">
                      ${badge.badge_title}
                    </div>`
                  }
                }
                  
                  newHtml = newHtml + `</div></div></div></div></li>`;



          /* newHtml = newHtml + `<li id="Slide-template--15006739365973__custom_grid_gfwVyU-1-${index}" class="grid__item slider__slide added-products" style="--animation-order: 1;" data-added_product="${el.handle}">
          <div class="card-wrapper product-card-wrapper underline-links-hover">
              <div class="card card--standard card--media" style="--ratio-percent: 100.0%;">
                <div class="card__inner color-background-2 gradient ratio" style="--ratio-percent: 100.0%;">
                  <div class="card__media">
                    <div class="media media--transparent media--hover-effect multiply-image">
                      <img src="${data.featured_image}" data-img_src="${data.featured_image}" alt="${el.name} sunglasses with replacement lenses" class="motion-reduce added-image" loading="lazy" width="300" height="300">
                    </div>
                  </div>
                  <div class="card__content">
                    <div class="card__information">
                      <h3 class="card__heading smaller"><a href="${el.url}" id="StandardCardNoMediaLink-template--15006739365973__custom_grid_gfwVyU-column_nExB99-${index}" class="full-unstyled-link">${el.name}
                      </a></h3>
                    </div>
                    <div class="card__badge ${badgePosition}"></div>
                  </div>
                </div>
                <div class="card__content">
                  <div class="card__information"><h3 class="inline-richtext h4 subtitle mb-0">Lenses for</h3><h4 class="card__heading h3 smaller mobile--h3" id="title-template--15006739365973__custom_grid_gfwVyU-column_nExB99-${index}"><a href="${el.url}" id="CardLink-template--15006739365973__custom_grid_gfwVyU-column_nExB99-${index}" class="full-unstyled-link">${el.name}</a></h4>
                    <div class="card-information">
                      <span class="caption-large light"></span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </li>` */
          section.querySelector('ul.product-grid').insertAdjacentHTML("afterbegin", newHtml);

        } catch (error) {
          console.error(`Error fetching /products/${el.handle}.js:`, error);
          throw error; // Re-throw the error to be caught later if needed
        }
      });
      Promise.allSettled(promises).then(() => {
        removeExtraItems(customGrid);
        const firstSlide = section.querySelector('ul.product-grid li:first-of-type');
        firstSlide.dispatchEvent(new CustomEvent("slider_updated", {bubbles: true}));
        console.log('promises all set')
        checkExtrasPrice(customGrid);
      });
    }
    // remove products that we're about to add
    customGridProductsToShow.forEach(el => {
      removeItem(customGrid, el.name)
    });
    fetchDataInParallel(customGridProductsToShow, customGrid);

    setTimeout(() => {
      checkImages();
    }, 1000);

    /* const firstSlide = customGrid.querySelector('ul.product-grid li:first-of-type');
    firstSlide.dispatchEvent(new CustomEvent("slider_updated", {bubbles: true})); */
    
    
  } // END if customGrid


  

});
